import { generateClient } from 'aws-amplify/api';
import * as mutations from "../graphql/mutations";

const client = generateClient();

const createNotification = async ({ id, userId, hasViewed, status, content, date, expiry }) => {
    try {
        const {
            data: { createNotification: createdNotification },
        } = await client.graphql({
            query: mutations.createNotification,
            variables: {
                input: {
                    id,
                    userId,
                    hasViewed,
                    status,
                    content,
                    date,
                    expiry
                },
            },
        });
        return createdNotification;
    } catch (ex) {
        console.error("Failed to create notification", ex);
    }
};

export default createNotification;